export const CONTACT_API = "/sendmail"; //## 문의하기
export const NEWS_API = "/news"; //## 보도자료

export default {
    CONTACT_API,
    NEWS_API
};